import { Link, useLocation } from 'react-router-dom';
import '../styles/Breadcrumb.css';

const routeNames = {
  'pacientes': 'Pacientes',
  'facturacion': 'Facturación',
  'calendario': 'Calendario',
  'editar': 'Editar',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  return (
    <nav className="breadcrumb-container">
      <Link to="/dashboard" className="breadcrumb-item home">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
        Panel
      </Link>
      {pathnames.map((segment, index) => {
        const routeTo = '/' + pathnames.slice(0, index + 1).join('/');
        const isLast = index === pathnames.length - 1;
        const name = routeNames[segment] || segment;

        return (
          <div key={index} className="breadcrumb-wrapper">
            <span className="separator">/</span>
            <Link 
              to={routeTo} 
              className={`breadcrumb-item ${isLast ? 'active' : ''}`}
            >
              {name}
            </Link>
          </div>
        );
      })}
    </nav>
  );
}
